const seeAll = (i) => {
  let contentAll;
  let btn_viewAll;
  let btnContent;
  let slides = document.querySelectorAll(".newCases__block");

  /* Плавный скролл */
  function scrollToTop() {
    let scropllBlock = document.querySelector("#newCases");
    if (scropllBlock) {
      scropllBlock.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  // Перебираем слайды
  for (let slide of slides) {
    contentAll = slide.querySelectorAll(".newCasesBlock__content");

    if (slide.getAttribute("data-id") == i) {
      btn_viewAll = slide.querySelector(".openBlock__link");
      btnContent = slide.querySelector(".openBlock__p");
      let contentAllSlide = slide.querySelectorAll(".newCasesBlock__content");
      btn_viewAll.classList.remove("active");
      btnContent.textContent = "Развернуть кейс";
      btn_viewAll.addEventListener("click", function (e) {
        e.stopImmediatePropagation();

        for (let item of contentAllSlide) {
          item.classList.toggle("disable");
          contentAllSlide[0].classList.remove("disable");
        }

        if (btn_viewAll.classList.contains("active")) {
          btn_viewAll.classList.remove("active");
          btnContent.textContent = "Развернуть кейс";
          scrollToTop()
        } else {
          btn_viewAll.classList.add("active");
          btnContent.textContent = "Свернуть кейс";
        }
      });
    }

    //Перебираем все параграфы каждого слайда и скрываем все кроме первого параграфы
    for (let item of contentAll) {
      item.classList.add("disable");
      contentAll[0].classList.remove("disable");
    }
  }
};

export default seeAll;
